import DotNetObject = DotNet.DotNetObject;
import { QxQuestionType } from '@crimsontide/core/client/interfaces';

export const QxQuestionTypeService = (() => {
  let dotNetObj: DotNetObject;
  let cachedQxQuestionTypes: QxQuestionType[];

  const setDotNetReference = (obj: DotNetObject): void => {
    dotNetObj = obj;
  };

  const getQxQuestionTypes = async (useCache: boolean = true): Promise<QxQuestionType[]> => {
    if (useCache && cachedQxQuestionTypes != null)
      return cachedQxQuestionTypes;

    if (dotNetObj) {
      cachedQxQuestionTypes = await dotNetObj.invokeMethodAsync<QxQuestionType[]>('GetAsync');
      return cachedQxQuestionTypes;
    } else {
      throw 'QxQuestionType DotNet Object Reference has not yet been implemented';
    }
  };

  return {
    setDotNetReference,
    getQxQuestionTypes,
  };
})();
